/** Cores das tags da organização (Administração → Tags e criação rápida na demanda). */
export const TAG_PALETTE = [
  '#22d3ee',
  '#a78bfa',
  '#a3e635',
  '#fbbf24',
  '#fb7185',
  '#60a5fa',
  '#f472b6',
  '#34d399',
  '#f97316',
  '#94a3b8',
] as const;

/** Cor estável pelo nome: a mesma tag criada de novo cai na mesma cor. */
export function tagColorFor(name: string): string {
  let h = 0;
  for (const ch of name.toLowerCase()) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return TAG_PALETTE[h % TAG_PALETTE.length]!;
}
